import axios, { defaultParams } from './axios';
export default function post(url, body, config) {
    const defaults = defaultParams();
    const mergedConfig = {
        ...defaults,
        ...(config ?? {}),
        headers: {
            ...(defaults.headers ?? {}),
            ...(config?.headers ?? {}),
        },
    };
    return axios.post(url, body, mergedConfig);
}
